export default __webpack_public_path__ + "static/img_welfare_6@2x-6be7ce3ea096479178a694183bf46cfd.jpg";